/*
  * Evaluation score counter, specific for Adalia M&E.
  * This is a composite based on other components.
  */
import React from 'react';

import { 
  Mode,
} from '../common.jsx';
import Helpers from './helpers.jsx';
import Setting from './setting.jsx';

import GridLayout from './grid_layout.jsx';

export default class AdaliaMEEvaluationScoreCounter extends GridLayout {

        static get CATEGORY() {
            return 'layout';
        }

        static get TYPE() {
            return 'adalia_me_evaluation_score_counter'
        }

        static get TRANSLATED_ATTRIBUTES() {
            return {
                label: 'evaluation_total'
            };
        }

        static defaultContent(language) {
            return Object.assign(super.defaultContent(language), {
                label: 'label',
                      name: "field_" + Helpers.randomString(),
                rows: [
                    [
                        {
                            span: 1,
                            component: null
                        }
                    ],
                    [
                        {
                            span: 1,
                            component: null
                        }
                    ]
                ]
            });
        }

        constructor(props) {
            super(props);
            this.updateTotalScore = this.updateTotalScore.bind(this);
        }

        componentDidMount() {
            super.componentDidMount();

            if ([Mode.VIEW, Mode.FILL, Mode.EDIT].indexOf(this.props.mode) != -1) {
                this.updateTotalScore();
            }
        }

        componentDidUpdate(prevProps, prevState) {
            super.componentDidUpdate();

            if ([Mode.FILL, Mode.EDIT].indexOf(this.props.mode) != -1) {
                this.updateTotalScore();
            }

            // Update answer for calculation component to use
            if (prevState.score != this.state.score) {
                this.updateAnswer();
            }
        }

        // Update value to answers
        updateAnswer() {
            if (this.props.updateAnswerCallback && this.props.mode == Mode.FILL) {
                this.props.updateAnswerCallback(
                    this.fullFieldName(),
                    (this.state.score || 0).toString()
                );
            }
        }

        updateTotalScore() {
            let totalScore = new Decimal(0);
            jQuery(this.refs.container).find('select[name*="[score]"]').each((i, e) => {
                let weight = new Decimal(jQuery(e).closest('.adalia_me_evaluation').find('input.weight').val() || 0);
                let val = new Decimal(jQuery(e).val() || 0);
                val = isNaN(val) ? new Decimal(0) : val
                totalScore = totalScore.plus(weight.times(val));
            });

            if (this.state.score != totalScore) {
                this.setState({ score: parseFloat(totalScore.toFixed()) });
            }
        }

        renderView() {
            return (
                <div ref="container">
                    {super.renderView()}
                    <div className="total">
                        {this.getText('label')}:
                        <span ref="total" className="value">{(this.state.score || 0).toString()}</span>
                    </div>
                </div>
            );
        }

        renderSettings() {
            return (
                <div>
                    {super.renderSettings()}
                    <Setting.TextField name="label" label={I18n.t('field_label', {scope: 'fe'})} value={this.getText('label')} onChange={this.updateSettings} />
                </div>
            )
        }
}
